import { useTranslation } from 'react-i18next';
import type { FirmwareState } from '../../types';

interface FirmwareStateLabelProps {
  state: FirmwareState;
}

const stateStyles: Record<FirmwareState, string> = {
  Draft: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
  Active: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  Surpassed: 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400',
};

export function FirmwareStateLabel({ state }: FirmwareStateLabelProps) {
  const { t } = useTranslation();

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${stateStyles[state]}`}
    >
      {t(`firmware.state.${state}`)}
    </span>
  );
}
